import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import { initialState as baseInitState } from '../../utils/redux/commonActionHandlers';
import { optionsOfStates } from './utils';

export const constants = getConstantsByFeatureName('CREW_CHANGES');
export const actions = getActionCreators(constants);
export const actionHandlers = getActionHandlers(constants);
export const selector = getSelectorByFeatureName('crewChanges');

const initialState = {
  ...baseInitState,
  // CREW-1042: no `sort` override here on purpose. The shared
  // `initialState` ships `{ field: "", direction: "asc" }`, so the first
  // request carries no `sort` param and the BE applies its default order
  // (planned first, nearest date on top) — see CrewChangeResource#apply_sort.
  filter: {
    state: optionsOfStates[0],
  },
};

export const reducer = buildReducer(initialState, {
    ...actionHandlers,
    [constants.CLEAR_FILTER]: (state) => ({
      ...state,
      filter: { ...initialState.filter },
    }),
  });
